export const skills = {
    ai: [
      "LangChain", "NLP", "LLMs (OpenAI, Anthropic, Gemini)", "RAG", "pgvector",
      "Elasticsearch", "Embeddings", "Guardrails", "RunwayML", "CrewAI",
      "Visão Computacional", "Deep Learning", "Machine Learning"
    ],
    mobile: [
      "Kotlin (Android Nativo)", "Swift (iOS Nativo)", "Flutter (Dart)",
      "React Native", "Java/C++ (JNI/NDK)"
    ],
    backend: [
      "Node.js", "NestJS", "Hono", "TypeScript", "Python", "FastAPI",
      "Django", "Flask", "Streamlit", "Java (Spring Boot)", "PHP (Laravel)", "C#/.NET"
    ],
    frontend: [
      "Next.js 14", "React", "Angular", "TypeScript", "Tailwind CSS", "shadcn/ui", "Vite"
    ],
    database: [
      "PostgreSQL", "MySQL", "MongoDB", "SQLite", "Firebase Firestore",
      "Elasticsearch", "pgvector", "Prisma", "Drizzle ORM", "TypeORM"
    ],
    cloud: [
      "AWS (S3, EC2)", "GCP", "Azure", "Firebase", "Vercel", "Render",
      "Railway", "Docker", "Jenkins", "GitHub Actions", "CI/CD"
    ],
    integrations: [
      "Stripe", "PIX", "Asaas", "Twilio", "Baileys (WhatsApp)", "Socket.IO",
      "OpenWeather", "SendGrid", "OAuth 2.0", "WebAuthn"
    ],
    soft: [
      "Liderança técnica", "Mentoria", "Arquitetura de software",
      "Trabalho em equipe", "Comunicação", "Resolução de problemas",
      "Gestão de tempo", "Flexibilidade"
    ]
  };

export const languages = [
    { name: "Português", level: "Nativo" },
    { name: "Inglês", level: "Avançado (5 anos: WiseUp, Wizard, Ibeu)" },
    { name: "Espanhol", level: "Intermediário" }
];

/* Titled, ordered view of `skills` for the Skills section grid. */
export const skillGroups = [
    { title: "Inteligência Artificial", items: skills.ai },
    { title: "Mobile", items: skills.mobile },
    { title: "Back-end", items: skills.backend },
    { title: "Front-end", items: skills.frontend },
    { title: "Dados", items: skills.database },
    { title: "Cloud & DevOps", items: skills.cloud },
    { title: "Integrações", items: skills.integrations },
    { title: "Soft Skills", items: skills.soft }
];
